/**
 * Configuración global de mutations
 */
export const ON_ROUTE = "ON_ROUTE";
export const ON_IS_LOADING = "ON_IS_LOADING";
export const ON_PASO_1 = "ON_PASO_1";
export const ON_PASO_1_SUCCESS = "ON_PASO_1_SUCCESS";
export const ON_PASO_2 = "ON_PASO_2";
export const ON_PASO_3 = "ON_PASO_3";
export const ON_PASO_4 = "ON_PASO_4";
export const ADOBE_APP_STARTED = "ADOBE_APP_STARTED";
export const ADOBE_APP_ON_CLICK_START = "ADOBE_APP_ON_CLICK_START";
export const ON_IS_EXCEEDED = "ON_IS_EXCEEDED";
export const ON_MOCK = "ON_MOCK";
export const ON_NOTIFICATION_TOAST = "ON_NOTIFICATION_TOAST";
